import { DeviceErrorMapper } from '@yandex-360/telemost-sdk/device-manager';
import type { DeviceErrorCode } from '@yandex-360/telemost-sdk/device-manager';
import { SdkError } from '@yandex-video-platform/goloom-sdk';

export class GoloomDeviceErrorMapper extends DeviceErrorMapper {
    toDeviceErrorCode(error: unknown): DeviceErrorCode {
        return error instanceof SdkError ? error.code : 'UNKNOWN';
    }
}
